import { useOrderSearchForm } from '@euler/app/flows/search/context';
import { FormGroup } from '@euler/components/form';
import { Input } from '@euler/components/form/Input';
import { memo } from 'react';

export const VINField = memo(() => {
  const { form } = useOrderSearchForm();

  return (
    <FormGroup label="车架号">
      <Input
        value={form.vin.value ?? ''}
        placeholder="按车架号搜索"
        clearButtonMode="always"
        keyboardType="numbers-and-punctuation"
        onChangeText={form.vin.update}
      />
    </FormGroup>
  );
});
